import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    background: #eef1f5;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    color: #1e293b;
    -webkit-font-smoothing: antialiased;
  }
`;

export const Page = styled.div`
  min-height: 100vh;
  background: #eef1f5;
  padding-bottom: 60px;
`;

export const TopBar = styled.header`
  background: #1f3864;
  color: #fff;
  padding: 0;

  .inner {
    max-width: 860px;
    margin: 0 auto;
    padding: 26px 20px 20px;

    .group {
      font-size: 0.78em;
      letter-spacing: 0.18em;
      font-weight: 600;
      opacity: 0.75;
      margin-bottom: 10px;
    }

    h1 {
      font-size: 1.45em;
      font-weight: 700;
      letter-spacing: -0.01em;
      line-height: 1.25;
    }

    .sub {
      margin-top: 8px;
      font-size: 0.88em;
      opacity: 0.85;
      line-height: 1.5;
    }

    .tags {
      display: flex;
      gap: 8px;
      margin-top: 14px;
      flex-wrap: wrap;

      span {
        font-size: 0.72em;
        padding: 4px 10px;
        border-radius: 999px;
        background: rgba(255,255,255,0.12);
        border: 1px solid rgba(255,255,255,0.18);
      }
    }
  }
`;

export const Container = styled.div`
  max-width: 860px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const Card = styled.section`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 26px 28px;
  margin-top: 22px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);

  @media (max-width: 640px) {
    padding: 20px 16px;
  }
`;

export const IntroCard = styled(Card)`
  p {
    font-size: 0.92em;
    line-height: 1.65;
    color: #334155;
    margin-bottom: 12px;

    &:last-child { margin-bottom: 0; }
    strong { color: #1f3864; }
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8em;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #1f3864;
  text-transform: uppercase;
  margin-bottom: 4px;

  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e2e8f0;
  }
`;

export const Question = styled.div`
  margin-top: 22px;

  .q-label {
    display: flex;
    gap: 8px;
    font-size: 0.92em;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.5;
    margin-bottom: 10px;

    .q-num {
      color: #1f3864;
      font-weight: 700;
      flex-shrink: 0;
    }
  }

  .q-note {
    font-size: 0.78em;
    color: #64748b;
    font-style: italic;
    margin: -4px 0 10px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 11px 14px;
  border: 1px solid #d8dee6;
  border-radius: 9px;
  font-size: 0.9em;
  font-family: inherit;
  color: #0f172a;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder { color: #94a3b8; }
  &:focus {
    outline: none;
    border-color: #1f3864;
    box-shadow: 0 0 0 3px rgba(31, 56, 100, 0.08);
  }
  &:disabled { background: #f1f5f9; color: #94a3b8; }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 90px;
  padding: 11px 14px;
  border: 1px solid #d8dee6;
  border-radius: 9px;
  font-size: 0.9em;
  font-family: inherit;
  color: #0f172a;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder { color: #94a3b8; }
  &:focus {
    outline: none;
    border-color: #1f3864;
    box-shadow: 0 0 0 3px rgba(31, 56, 100, 0.08);
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid ${({ $checked }) => ($checked ? "#1f3864" : "#e2e8f0")};
  border-radius: 9px;
  background: ${({ $checked }) => ($checked ? "rgba(31,56,100,0.05)" : "#fff")};
  cursor: pointer;
  font-size: 0.88em;
  line-height: 1.45;
  color: #334155;
  transition: all 0.15s ease;

  &:hover { border-color: #94a3b8; }

  .box {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 1px;
    border: 1.5px solid ${({ $checked }) => ($checked ? "#1f3864" : "#cbd5e1")};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1f3864;
    font-weight: 800;
    font-size: 0.8em;
    line-height: 1;
  }

  input { display: none; }
`;

export const InlineField = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 8px;

  input { flex: 1; }
`;

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Grid4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const FieldLabel = styled.div`
  font-size: 0.75em;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const LegalBox = styled.div`
  background: #fbf7ec;
  border: 1px solid #eadfc0;
  border-left: 4px solid #d9a527;
  border-radius: 8px;
  padding: 16px 18px;
  margin-top: 20px;

  .lb-title {
    font-size: 0.72em;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: #8a6d1d;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.85em;
    line-height: 1.6;
    color: #4b5563;
    margin-bottom: 10px;

    &:last-child { margin-bottom: 0; }
  }
`;

export const TermsBox = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 18px;
  margin-top: 14px;
  background: #fafbfc;
  max-height: 320px;
  overflow-y: auto;

  p {
    font-size: 0.85em;
    line-height: 1.65;
    color: #374151;
    margin-bottom: 12px;

    strong { color: #0f172a; }
  }
`;

export const SubmitBar = styled.div`
  max-width: 860px;
  margin: 26px auto 0;
  padding: 0 20px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 12px;
  background: #1f3864;
  color: #fff;
  font-size: 1em;
  font-weight: 700;
  font-family: inherit;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover:not(:disabled) { background: #16294a; transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const ErrorList = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 14px 18px;
  margin-top: 20px;

  .title {
    font-weight: 700;
    color: #b91c1c;
    font-size: 0.85em;
    margin-bottom: 8px;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    font-size: 0.82em;
    color: #991b1b;
    line-height: 1.6;
  }
`;

export const SuccessWrap = styled.div`
  max-width: 640px;
  margin: 60px auto;
  padding: 0 20px;
  text-align: center;

  .icon {
    width: 72px;
    height: 72px;
    margin: 0 auto 20px;
    border-radius: 50%;
    background: #dcfce7;
    color: #16a34a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
  }

  h2 {
    font-size: 1.4em;
    color: #0f172a;
    margin-bottom: 10px;
  }

  p {
    color: #475569;
    font-size: 0.92em;
    line-height: 1.6;
    margin-bottom: 8px;
  }

  .protocol {
    display: inline-block;
    margin-top: 16px;
    padding: 10px 22px;
    background: #fff;
    border: 1px dashed #cbd5e1;
    border-radius: 10px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.85em;
    color: #1f3864;
  }
`;

export const Footer = styled.footer`
  text-align: center;
  margin-top: 40px;
  font-size: 0.75em;
  color: #94a3b8;
`;
